import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { RemoveScroll } from 'react-remove-scroll';
import { Modal as ReactResponsiveModal } from 'react-responsive-modal';
import IconClose from 'components/icons/iconClose';
import 'react-responsive-modal/styles.css';
const modalCloseIcon = <div className="items-center flex justify-center h-[35px] w-[35px]">
    <IconClose color="#ffffff" height={21} width={21} />
  </div>;
const Modal = t0 => {
  const $ = _c(10);
  let open;
  let props;
  if ($[0] !== t0) {
    ({
      open,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = open;
    $[2] = props;
  } else {
    open = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = document.querySelector("#react-responsive-modal-root");
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const container = t1;
  let t2;
  if ($[4] !== open || $[5] !== props) {
    t2 = <ReactResponsiveModal blockScroll={false} closeIcon={modalCloseIcon} container={container} open={open} {...props} />;
    $[4] = open;
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== open || $[8] !== t2) {
    t3 = <RemoveScroll enabled={open} removeScrollBar={false}>{t2}</RemoveScroll>;
    $[7] = open;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
Modal.propTypes = {
  open: PropTypes.bool
};
export default Modal;